<template>
  <div>
    <iframe
      class="w-full h-[352px] lg:h-[641px]"
      style="border-radius: 12px"
      :src="audioUrl"
      width="100%"
      frameBorder="0"
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    audioUrl: {
      type: String,
      required: true,
    },
  },
};
</script>
